import React, { PureComponent } from 'react'
import { View, Platform } from 'react-native'
import { lighten } from 'polished'
import styled from 'styled-components/native'

import { Text } from '../../Atoms/Typography'
import Icon from '../../Atoms/Icon'
import ValueChangeText from '../../Molecules/ValueChangeText'

import theme from '../../../styles/theme'

const isIOS = Platform.OS === 'ios'

const green = lighten(0.25, theme.colours.green)
const red = lighten(0.45, theme.colours.red)

export const IMPACTS = {
  BAD: 'bad',
  GOOD: 'good',
  NONE: 'non'
}

const Card = styled(View)`
  padding: ${theme.gutterUnit / 2}px;
  width: 50%;
  height: 33.3%;
`

const CardContent = styled(View)`
  padding: ${theme.gutterUnit / 2}px;
  border-top-left-radius: ${theme.gutterUnit}px;
  border-top-right-radius: ${theme.gutterUnit}px;
  flex: 6;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.impact === IMPACTS.GOOD ? green : props.impact === IMPACTS.BAD ? red : theme.colours.lightgrey};
  border-color: ${props => props.borderColour};
  border-width: 3px;
`

const CardMetrics = styled(View)`
  border-bottom-left-radius: ${theme.gutterUnit}px;
  border-bottom-right-radius: ${theme.gutterUnit}px;
  flex: 4;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #eeeeee;
  borderLeftColor: ${props => props.borderColour};
  borderLeftWidth: 3px;
  borderRightColor: ${props => props.borderColour};
  borderRightWidth: 3px;
  borderBottomColor: ${props => props.borderColour};
  borderBottomWidth: 3px;
`

const ValueRow = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const IconContainer = styled(View)`
  padding-bottom: ${theme.gutterUnit / 2}px;
`

const colours = [
  theme.colours.orange,
  theme.colours.magenta,
  theme.colours.blue,
  theme.colours.purple,
  theme.colours.third,
  theme.colours.darkBlue
]

export default class ImpactWidget extends PureComponent {
  render () {
    const { index, icon = 'home', heading, change, value, isCost, changeUnit, impact } = this.props
    const colour = colours[index % colours.length]

    return (
      <Card>
        <CardContent borderColour={colour} impact={impact}>
          <Text proximaBold center size={isIOS ? 'm' : 's'}>{heading.toUpperCase()}</Text>
          <IconContainer>
            <Icon height={isIOS ? 50 : 35} name={icon} colour={colour} />
          </IconContainer>
        </CardContent>
        <CardMetrics borderColour={colour}>
          <ValueRow>
            <ValueChangeText dp={0} size={isIOS ? 'xxl' : 'xl'} medium value={change} isCost={isCost} changeUnit={changeUnit} dashIfZero />
          </ValueRow>
          <ValueRow>
            <Text size={isIOS ? 'l' : 'm'} medium colour={colour}>{value}</Text>
          </ValueRow>
        </CardMetrics>
      </Card>
    )
  }
}
